import React from 'react';
import { toast } from 'sonner';

const AdminActions = ({ jobSeekerId, isBlacklisted }) => {
  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this job seeker?')) {
      try {
        const response = await fetch(`${process.env.REACT_URL}/api/v1/jobseeker/delete/${jobSeekerId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          toast.success('Job seeker deleted successfully');
          window.location.reload(); // Refresh to update the table
        } else {
          toast.error(data.message || 'Failed to delete job seeker');
        }
      } catch (error) {
        console.error('Delete Error:', error);
        toast.error('An error occurred while deleting');
      }
    }
  };

  const handleBlacklist = async () => {
    if (window.confirm(`Are you sure you want to ${isBlacklisted ? 'unblacklist' : 'blacklist'} this job seeker?`)) {
      try {
        const response = await fetch(`${process.env.REACT_URL}/api/v1/jobseeker/blacklist/${jobSeekerId}`, {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ isBlacklisted: !isBlacklisted }),
        });
        const data = await response.json();
        if (response.ok) {
          toast.success(`Job seeker ${isBlacklisted ? 'unblacklisted' : 'blacklisted'} successfully`);
          window.location.reload(); // Refresh to update the table
        } else {
          toast.error(data.message || 'Failed to update blacklist status');
        }
      } catch (error) {
        console.error('Blacklist Error:', error);
        toast.error('An error occurred while updating blacklist');
      }
    }
  };

  return (
    <div className="space-x-2">
      <button onClick={handleDelete} className="bg-red-500 text-white p-1 rounded mb-2 rounded-md">Delete</button>
      <button onClick={handleBlacklist} className="bg-yellow-500 text-white p-1 rounded-md">
        {isBlacklisted ? 'Unblacklist' : 'Blacklist'}
      </button>
    </div>
  );
};

export default AdminActions;